import { render, staticRenderFns } from "./UpdateConcept.vue?vue&type=template&id=09cafddd&scoped=true"
import script from "./UpdateConcept.vue?vue&type=script&lang=js"
export * from "./UpdateConcept.vue?vue&type=script&lang=js"
import style0 from "./UpdateConcept.vue?vue&type=style&index=0&id=09cafddd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cafddd",
  null
  
)

export default component.exports